import { axios } from "../utils/axios";
import { toast } from "react-toastify";
import { toastOptions } from "../config/toast";
import { useGeneralAppStore } from "../store/generalAppStore";
import { isAxiosError } from "axios";

const { handlerLoading, handlerModal } = useGeneralAppStore.getState();

//^TRAE TODO LOS TIPOS DE SOLICITUDES
export const getTiposSolicitudes = async () => {
  handlerLoading({ loading: true, loadName: "tipos_solicitudes" });
  try {
    const response = await axios().get("tipos_solicitudes");
    if (!isAxiosError(response)) {
      const { data, error } = response.data;
      if (error) toast.error(error, toastOptions);
      return data;
    }
  } catch (error) {
    toast.error("Hubo un error en la consulta", toastOptions);
  } finally {
    handlerLoading({ loading: false, loadName: "tipos_solicitudes" });
  }
};

//^TRAE TODA LAS ACTAS DEL USUARIO
export const getMisActas = async () => {
  handlerLoading({ loading: true, loadName: "mis_actas" });
  try {
    const response = await axios().get("mis_actas");
    if (!isAxiosError(response)) {
      const { data, error } = response.data;
      if (error) toast.error(error, toastOptions);
      return data;
    }
  } catch (error) {
    toast.error("Hubo un error en la consulta", toastOptions);
  } finally {
    handlerLoading({ loading: false, loadName: "mis_actas" });
  }
};

//^TRAE UN ACTA DEL USUARIO
export const getActa = async (id) => {
  handlerLoading({ loading: true, loadName: "get_acta" });
  try {
    const response = await axios().get(`acta/${id}`);
    if (!isAxiosError(response)) {
      const { data, error } = response.data;
      if (error) toast.error(error, toastOptions);
      return data;
    }
  } catch (error) {
    toast.error("Hubo un error en la consulta", toastOptions);
  } finally {
    handlerLoading({ loading: false, loadName: "get_acta" });
  }
};

//^CAMBIA ESTADO DE UN ACTA
export const cambiarEstadoActa = async (payload) => {
  handlerLoading({ loading: true, loadName: "cambiar_estado" });
  try {
    const response = await axios().post(`acta/cambiar_estado/${payload}`);
    if (!isAxiosError(response)) {
      const { data, error } = response.data;
      if (error) toast.error(error, toastOptions);
      if (data.estado_id == 2) {
        toast.success("El acta fue aceptada", toastOptions);
      }
      if (data.estado_id == 8) {
        toast.success("El acta fue finalizada", toastOptions);
      }
      return data;
    }
  } catch (error) {
    toast.error("Hubo un error en la consulta", toastOptions);
  } finally {
    handlerLoading({ loading: false, loadName: "cambiar_estado" });
  }
};

//^CAMBIA UN ACTA A CANCELADA
export const cancelarActa = async (payload) => {
  handlerLoading({ loading: true, loadName: "cambiar_estado" });
  try {
    const response = await axios().get(`acta/cancelar_acta/${payload}`);
    if (!isAxiosError(response)) {
      const { data, error } = response.data;
      if (error) toast.error(error, toastOptions);
      toast.error("El acta fue cancelada", toastOptions);
      handlerModal({ modal: false, modalName: "cancelar_acta" });
      return data;
    }
  } catch (error) {
    toast.error("Hubo un error en la consulta", toastOptions);
  } finally {
    handlerLoading({ loading: false, loadName: "cambiar_estado" });
  }
};

//^CAMBIAR ESTADO DE ACTA A FINALIZADO
export const finalizarACta = async (payload) => {
  handlerLoading({ loading: true, loadName: "finalizar_acta" });
  try {
    const response = await axios().post(`acta/finalizar_acta`, payload);
    if (!isAxiosError(response)) {
      const { data, error } = response.data;
      if (error) return toast.error(error, toastOptions);
      toast.success("El acta finalizada", toastOptions);
      handlerModal({ modal: false, modalName: "finalizar_acta" });
      return data;
    }
  } catch (error) {
    toast.error("Hubo un error en la consulta", toastOptions);
  } finally {
    handlerLoading({ loading: false, loadName: "finalizar_acta" });
  }
};

//^MANDA PRIMERA ETRAPA DEL FORMULARIO
export const primeraEtapa = async (payload) => {
  handlerLoading({ loading: true, loadName: "load_form" });
  try {
    const response = await axios().post("/acta/primera_etapa", payload);
    const { data, error } = response.data;
    if (error) {
      toast.error(error, toastOptions);
      return null;
    }
    return data;
  } catch (error) {
    toast.error("Hubo un error en la consulta", toastOptions);
  } finally {
    handlerLoading({ loading: false, loadName: "load_form" });
  }
};

//^MANDA SEGUNDA ETRAPA DEL FORMULARIO
export const segundaEtapa = async (payload, id) => {
  const formData = new FormData();
  if (payload.id) {
    formData.append("id", payload.id);
  }
  if (payload.lugar) {
    formData.append("lugar", payload.lugar);
  }
  if (payload.tipo_persona_solicitante) {
    formData.append("tipo_persona_solicitante", payload.tipo_persona_solicitante);
  }
  if (payload.solicitante) {
    formData.append("solicitante", payload.solicitante);
  }
  if (payload.tipos_solicitud) {
    // formData.append("tipos_solicitud", payload.tipos_solicitud);
    payload.tipos_solicitud.forEach((item, index) => {
      formData.append(`tipos_solicitud[${index}][id]`, item.id);
      formData.append(`tipos_solicitud[${index}][cantidad_arboles]`, item.cantidad_arboles);
    });
  }
  if (payload.descripcion) {
    formData.append("descripcion", payload.descripcion);
  }
  if (payload.descripcion) {
    formData.append("descripcion", payload.descripcion);
  }
  if (payload.latitud) {
    formData.append("latitud", payload.latitud);
  }
  if (payload.longitud) {
    formData.append("longitud", payload.longitud);
  }
  if (payload.ubicacion) {
    formData.append("ubicacion", payload.ubicacion);
  }
  if (payload.files) {
    payload.files.forEach((file, index) => {
      formData.append(`files[${index}]`, file);
    });
  }

  handlerLoading({ loading: true, loadName: "load_form" });
  try {
    const response = await axios().post(`/acta/segunda_etapa/${payload.id}`, formData);
    const { data, error } = response.data;
    if (error) {
      toast.error(error, toastOptions);
      return null;
    }
    return data;
  } catch (error) {
    toast.error("Hubo un error en la consulta", toastOptions);
  } finally {
    handlerLoading({ loading: false, loadName: "load_form" });
  }
};

//^MANDA TERCERA ETRAPA DEL FORMULARIO
export const terceraEtapa = async (payload, id) => {
  handlerLoading({ loading: true, loadName: "tercera_etapa" });
  try {
    const response = await axios().post(
      `/acta/tercera_etapa/${id}`,
      { files: payload },
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    const { data, error } = response.data;
    if (error) {
      toast.error(error, toastOptions);
      return null;
    }
    return data;
  } catch (error) {
    toast.error("Hubo un error en la consulta", toastOptions);
  } finally {
    handlerLoading({ loading: false, loadName: "tercera_etapa" });
  }
};
